import { useQuery, queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { Ref } from "vue";

interface ListPartsQueryOptions {
  limit?: Ref<number>;
  offset?: Ref<number>;
}

export const listPartsQuery = (options: ListPartsQueryOptions) => {
  return queryOptions({
    queryKey: ["parts", "list", options.limit, options.offset],
    queryFn: async () => {
      return handleClientMethod(
        getClient().GET("/parts", {
          params: {
            query: {
              limit: options.limit?.value,
              offset: options.offset?.value,
            },
          },
        }),
      );
    },
  });
};

export const useListParts = (options: ListPartsQueryOptions) => {
  return useQuery(listPartsQuery(options));
};
